// extracted by mini-css-extract-plugin
export var alertContainer = "AlertBanner-module--alertContainer--bdcb9";
export var alertText = "AlertBanner-module--alertText--df444";
export var closeIcon = "AlertBanner-module--closeIcon--e898a";
export var iconContainer = "AlertBanner-module--iconContainer--02590";